import React from "react";
import { connect } from "react-redux";
import { Popup, Button, ValidationGroup } from "devextreme-react";
import TextField from "../../../../Shared/fields/TextField";
import { setBatery, openCloseModalEditarBateria, doAddBateria, doUpdateBateria, openCloseModalDesactivarBateria } from "./action";
import TagField from "../../../../Shared/fields/TagField";
import SwitchField from "../../../../Shared/fields/SwitchField";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalEditar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activoPrev: null,
    };
  }

  componentDidUpdate = (preProps) => {
    if (!preProps.isOpenModalEditar && this.props.isOpenModalEditar) {
      const { batery } = this.props;
      this.setState({ activoPrev: batery.Status });
    }
  }

  handleChange = (e) => {
    const newBatery = { ...this.props.batery };
    if(e.element.id === "BatteryStatus"){
      e.element.id = "Status";
    }
    newBatery[e.element.id] = e.value;
    this.props.dispatch(setBatery(newBatery));
  }

  handleChangeTag = (e) => {
    const newBatery = { ...this.props.batery };
    const newValueList = e.component._selectedItems.map((e) => e.Id);
    newBatery[e.element.id] = newValueList;
    this.props.dispatch(setBatery(newBatery));
  }

  handleCancel = () => {
    this.props.dispatch(openCloseModalEditarBateria(false, {}, false));
  }

  handleSave = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      if (this.props.isNewBatery) {
        this.props.dispatch(doAddBateria(this.props.batery));
      } else if (this.state.activoPrev && !this.props.batery.Status) {
        this.props.dispatch(openCloseModalDesactivarBateria(true, this.props.batery));
      } else {
        this.props.dispatch(doUpdateBateria(this.props.batery));
      }
    }
  }

  render() {
    const { batery } = this.props;
    let title = "Editar Batería";
    let saveText = "Guardar";

    if (this.props.isNewBatery) {
      title = "Agregar Batería";
      saveText = "Agregar";
    }
    return (
      <Popup
        title={title}
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEditar && !this.props.isOpenModalDesactivar}
        width={700}
        height={445}
        contentComponent={() => (
          <div>
            {this.props.isLoading && <LoadingOverlay />}
            <ValidationGroup >
              <TextField
                id="Description"
                label="Nombre de la batería"
                maxLength={60}
                value={batery.Description}
                onChange={this.handleChange}
              />

              <SwitchField
                id="BatteryStatus"
                label="Activado"
                value={!!batery.Status}
                onChange={this.handleChange}
                switchedOffText="No"
                switchedOnText="Si"
                visible
              />
              <TagField
                label={`Prestaciones${ batery.ExamsCount ? ` (${batery.ExamsCount})` : ""}`}
                items={this.props.listaPrestaciones}
                defaultValue={batery.listExams}
                showSelectionControls
                maxDisplayedTags={2}
                showMultiTagOnly={false}
                displayExpr="Description"
                valueExpr="Id"
                selectAllMode="allPages"
                id="listExams"
                validation={!!batery.Status && batery.listExams}
                onClosed={this.handleChangeTag}
                searchEnabled
                tagTemplate={(i, e) => `<div id='tag${i.Id}' class="dx-tag-content" style="padding-right: 10px">
                    <span>${i.Description || i}</span>
                  </div>`}
              />

              <div className="button-row">
                <div>
                  <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
                </div>
                <div>
                  <Button text={saveText} type="success" onClick={this.handleSave} useSubmitBehavior />
                </div>
              </div>
            </ValidationGroup>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEditar: state.mantenedorBaterias.isOpenModalEditar,
  isOpenModalDesactivar: state.mantenedorBaterias.isOpenModalDesactivar,
  batery: state.mantenedorBaterias.batery,
  isNewBatery: state.mantenedorBaterias.isNewBatery,
  isLoading: state.mantenedorBaterias.isLoading,
  tiposBateria: state.mantenedorBaterias.tiposBateria,
  listaPrestaciones: state.mantenedorBaterias.listaPrestaciones,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditar);
